import * as Types from 'src/actions/home-banner/get/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'src/reducers/RootReducer';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import HomeBanner from 'src/entities/HomeBanner';

export interface GetHomeBannerAttempt extends Action {
  type: Types.GET_HOME_BANNER_ATTEMPT;
}

export interface GetHomeBannerSuccess extends Action {
  type: Types.GET_HOME_BANNER_SUCCESS;
  payload: HomeBanner;
}

export interface GetHomeBannerFailure extends Action {
  type: Types.GET_HOME_BANNER_FAILURE;
  payload: {};
}

export type GetHomeBannerAction =
  GetHomeBannerAttempt
  | GetHomeBannerSuccess
  | GetHomeBannerFailure;

export interface GetHomeBannerThunk extends
  ThunkAction<Promise<GetHomeBannerAction>, RootState, null> {
}

export const getHomeBannerAttempt: ActionCreator<GetHomeBannerAttempt> = () => (
  {type: Types.GET_HOME_BANNER_ATTEMPT}
);

export const getHomeBannerSuccess: ActionCreator<GetHomeBannerSuccess> = (
  successPayload: HomeBanner
) => (
  {
    type: Types.GET_HOME_BANNER_SUCCESS,
    payload: successPayload
  }
);

export const getHomeBannerFailure: ActionCreator<GetHomeBannerFailure> = (error: {}) => (
  {
    type: Types.GET_HOME_BANNER_FAILURE,
    payload: error
  }
);

export const getHomeBanner: ActionCreator<GetHomeBannerThunk> = (
  ): GetHomeBannerThunk => {

  return (dispatch: Dispatch<RootState>): Promise<GetHomeBannerAction> => {
    dispatch(getHomeBannerAttempt());
    
    return ApiClient.homeBanner.get('')
      .then((response: AxiosResponse<HomeBanner>): GetHomeBannerSuccess => {

        const successPayload: HomeBanner = response.data;

        return dispatch(getHomeBannerSuccess(successPayload));
      }).catch((e: { response: { data: { error: Error } } }): GetHomeBannerFailure => {
        const errorMessages = e && e.response && e.response.data && e.response.data.error || {
          serverConnection: 'Error en la conexión, por favor inténtelo más tarde'
        };
        return dispatch(getHomeBannerFailure(errorMessages));
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/home-banner/get/GetHomeBanner.actions.tsx